var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgByn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3642_19885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25984 18.5505L6.08594 14.6065L8.25984 10.7244L10.4337 14.6065L8.25984 18.5505Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91219 18.5505L1.73828 14.6065L3.91219 10.7244L6.0861 14.6065L3.91219 18.5505Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25984 29.2753L6.08594 25.3313L8.25984 21.4492L10.4337 25.3313L8.25984 29.2753Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91219 29.2753L1.73828 25.3313L3.91219 21.4492L6.0861 25.3313L3.91219 29.2753Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4334 3.88202L9.81789 2.78296C8.71398 3.43702 7.67859 4.19429 6.72461 5.04147L8.25945 7.82593L10.4334 3.88202Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26008 32.1736L6.70898 34.9436C7.66211 35.7919 8.6968 36.5503 9.80023 37.2057L10.4341 36.0558L8.26008 32.1736Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1738 25.2173V38.4097C14.5777 39.4329 17.2224 39.9999 19.9999 39.9999C28.5992 39.9999 35.9301 34.5724 38.7559 26.9563L12.1738 25.2173Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7559 26.9565C39.5599 24.7898 39.9999 22.4464 39.9999 20C39.9999 8.95437 31.0455 0 19.9999 0C17.2227 0 14.5777 0.566641 12.1738 1.58969V26.9566H38.7559V26.9565Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3642_19885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByn);
export default __webpack_public_path__ + "static/media/BYN.708b3ef2a487627a4b1b08ff94c30699.svg";
export { ForwardRef as ReactComponent };